<template>
  <div id="checkout">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section>
        <div
          class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60"
        >
          <div class="l-main__head">
            <a
              href="javascript:void(0)"
              @click.prevent="isShowConfirmReservation()"
              class="l-main__head--control l-main__head--control--back"
            >
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="" />
            </a>
            <div class="l-main__head--title">{{cartData[0]?.totalAmount > 0 ? "お支払い" : "リストを確認"}}</div>
            <a href="javascript:void(0)" class="l-main__head--control"> </a>
          </div>
          <div class="l-check-cart" v-for="(tenantCart, index) in cartData" :key="index">
            <div class="l-check-cart__head">
              <div class="l-check-cart__title">{{getTenantName(tenantCart.tenantId)}}</div>
              <div class="c-estimated-group c-estimated-group--vertical-center c-estimated-group--xl" v-if="isEnableTimebase(tenantCart) || tenantCart.orderType == 2">
                <div class="c-estimated c-estimated-horizon">
                  <img src="/assets/images/icon/icon-clock.svg" alt="" />受け取り目安
                </div>
                <div class="c-estimated-time">{{getEstimateTime(tenantCart)}}</div>
              </div>
              <hr />
              <div>
                <div class="l-check-cart__title-sub">{{tenantCart.orderType == '3' ? 'ご予約内容' : 'ご注文商品'}}</div>
                <div :class="{'c-cart-box':true, 'c-cart-box--payment': true, 'mb-32': index > 0, 'mb-16': index == 0 }" v-for="(product, index) in tenantCart.orderProducts" :key="index">
                  <div class="c-cart-box__head">
                    <div class="c-cart-box__img product-image">
                      <img :src="getImgSrc(product.image)" alt="" />
                    </div>
                  </div>
                  <div class="c-cart-box__body">
                    <ul>
                      <li>
                        <div class="c-cart-box__name">点数</div>
                        <div class="c-cart-box__price">{{product.quantity}}点</div>
                      </li>
                      <li>
                        <div class="c-cart-box__name">{{product.productName}}</div>
                        <div class="c-cart-box__price" v-if="getPrice(product,tenantCart) > 0">
                          {{priceFormat(getCartProductPriceTaxed(product, tenantCart.handlingFormat == '2' ? 'pickup' : '', tenantCart.handlingFormatSetting))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-if="product.discountAmount > 0">
                        <div class="c-cart-box__name">クーポン券適用</div>
                        <div class="c-cart-box__price">
                          <small class="discount">（-{{priceFormat(product.discountAmount)}}円）</small>
                        </div>
                      </li>
                      <li v-for="(option, optionIndex) in product.options" :key="optionIndex">
                        <div class="c-cart-box__name">{{option.optionName}}</div>
                        <div class="c-cart-box__price" v-if="getPrice(product,tenantCart) > 0">
                          {{priceFormat(getCartOptionPriceTaxed(product, option, tenantCart.handlingFormat == '2' ? 'pickup' : '', tenantCart.handlingFormatSetting))}}円<br /><small>（税込）</small>
                        </div>
                      </li>
                      <li v-if="getTenantTimebaseReservation(tenantCart.tenantId) && tenantCart.reservationNumberOfPeople > 0 ">
                        {{tenantCart.reservationNumberOfPeople}} 人
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="l-check-cart__body">
              <div class="c-calc-price mb-8">
                <ul class="mb-16">
                  <li>
                    <div>合計点数</div>
                    <div>{{getProductCount(tenantCart)}}点</div>
                  </li>
                  <li v-if="tenantCart.priceAmount1 > 0">
                    <div><small>小計</small><small>（税率8% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.priceAmount1)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.priceAmount2 - tenantCart.comissionFee > 0">
                    <div><small>小計</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.priceAmount2 - tenantCart.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.comissionFee > 0">
                    <div><small>手数料</small><small>（税率10% 税別）</small></div>
                    <div><small>{{priceFormat(tenantCart.comissionFee)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.taxAmount1 > 0">
                    <div><small>税額(8%)</small></div>
                    <div><small>{{priceFormat(tenantCart.taxAmount1)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.taxAmount2 > 0">
                    <div><small>税額(10%)</small></div>
                    <div><small>{{priceFormat(tenantCart.taxAmount2)}}円</small></div>
                  </li>
                  <li v-if="tenantCart.discountAmount > 0">
                    <div><small>クーポン券適用</small></div>
                    <div><small class="discount">-{{priceFormat(tenantCart.discountAmount)}}円</small></div>
                  </li>
                  <hr />
                  <li v-if="tenantCart.totalAmount > 0">
                    <div>合計<small>（税込）</small></div>
                    <div>{{priceFormat(tenantCart.totalAmount)}}円</div>
                  </li>
                </ul>
                <div class="mb-8" v-if="tenantCart.totalAmount > 0">
                  ※消費税は小計に記載の本体価格に対し計算の上、合計(税込)額を表示しています<br />
                  ※消費税の計算により店頭価格と端数が異なる場合がございます
                </div>
              </div>
              <!-- 来店予約の場合は表示しない -->
              <div class="c-box-method mb-8" v-if="index+1 == cartData.length && totalAmount > 0 && tenantCart.orderType != '3' ">
                <div class="l-check-cart__title-sub mb-10">クーポンコード</div>
                <div class="c-btn c-btn--red box-center mb-10" style="margin:0; width: 100%" @click.prevent="viewCoupon()">使えるクーポンを見る</div>
                <div class="c-box-coupon-group">
                  <div class="c-box-coupon mb-16">
                    <input type="text" value="" v-model="tmpCouponCode" />
                    <button @click.prevent="applyCoupon(tmpCouponCode)">適用</button>
                  </div>
                  <div class="mb-8">
                    お持ちのクーポンコードを入力してください。<br />
                    ※使えるクーポンコードが複数あった場合、1会計につき1枚のみご利用いただけます
                  </div>
                  <div class="d-flex justify-content-end mb-8">
                    <a class="c-box-coupon-group__cancel" href="javascript:void(0)" @click.prevent="cancelCoupon(tenantCart)"
                      >クーポンを取り消す</a
                    >
                  </div>
                </div>
              </div>
              <div class="c-box-method mb-8" v-if="tenantCart.handlingFormat == '1' || tenantCart.handlingFormat == '2' || index+1 == cartData.length && tenantCart.orderType !== 3">
                <div class="c-box-method__title mb-16">ご利用方法</div>
                <ul class="no-border">
                  <li>
                    <label for="radio-1" class="c-box-method__name" v-if="tenantCart.handlingFormat == '1'">
                      持ち帰り用
                    </label>
                    <label for="radio-1" class="c-box-method__name" v-if="tenantCart.handlingFormat == '2'">
                      店内でお食事<br />
                      <template v-if="tenantCart.deliveryPlaceDetail.tableNo">・テーブル番号：T-{{tenantCart.deliveryPlaceDetail.tableNo}}</template>
                    </label>
                    <label for="radio-1" class="c-box-method__name" v-if="tenantCart.handlingFormat == '3'">
                      {{mobileOrderConfig.drivethruAreaName}}で受け取り<br />
                      ・{{tenantCart.deliveryPlaceDetail.carNo}}（{{tenantCart.deliveryPlaceDetail.carColor}}）
                    </label>
                    <label for="radio-1" class="c-box-method__name" v-if="tenantCart.handlingFormat == '4'">
                      {{mobileOrderConfig.parkAndPickupAreaName}}で受け取り<br />
                      ・{{tenantCart.deliveryPlaceDetail.carNo}}（{{tenantCart.deliveryPlaceDetail.carColor}}）<br />
                      ・{{tenantCart.deliveryPlaceDetail.parkingNo}}
                    </label>
                    <label for="radio-1" class="c-box-method__name" v-if="tenantCart.handlingFormat == '5'">
                      ご来店予約
                    </label>
                  </li>
                </ul>
              </div>
              <!-- TODO 時間指定予約を使用している場合のみ表示させる -->
              <div class="c-box-method" v-if="getSelectDate(tenantCart.tenantId,tenantCart.orderType)">
                <div class="c-box-method__title mb-16">ご予約日時</div>
                <p>{{registReservationDate(tenantCart)}}</p>
                <div class="c-btn_reservationDate" v-on:click="showCalendar(tenantCart)">
                  <img src="/assets/images/icon/icon-calendar-ver2.svg" alt="" />
                  予約日時を選ぶ
                </div>
              </div>
              <div class="c-box-method mb-8" v-if="tenantCart.receiveDate">
                <div class="c-box-method__title mb-16">お受け取り日</div>
                <ul class="no-border">
                  <li>
                    <label for="radio-1" class="c-box-method__name">
                      {{formatDateForOrder(tenantCart.receiveDate)}} 
                    </label>
                  </li>
                </ul>
              </div>
              <div class="c-box-method" v-if="user && (!userAeonRegi || renewCard) && (cartData[0].orderType != 3 || cartData[0].totalAmount > 0) && index+1 == cartData.length">
                <div class="c-box-method">
                  <div class="c-box-method__title mb-12">
                      ※利用できるクレジットカードはイオンカードとVISA, Mastercardです。
                  </div>
                  <div class="l-check-cart__title-sub text-right mb-8">
                    <img src="/assets/images/icon/icon-logo-aeon.png" style="width: 25px; height: 25px;" alt="">
                    <img src="/assets/images/icon/icon-logo-mastercard.png" style="width: 35px; height: 25px;" alt="">
                    <img src="/assets/images/icon/icon-logo-visa.png" style="width: 45px; height: 20px;" alt="">
                  </div>
                </div>
                <div class="c-btn c-btn--red box-center" @click.prevent="registerCard">
                  クレジットカードの登録に進む
                </div>
              </div>
              <div class="c-box-method" v-else-if="user && userAeonRegi && (cartData[0].orderType != 3 || cartData[0].totalAmount > 0) && !renewCard && index+1 == cartData.length">
                <div class="c-box-method__title mb-12">
                  <img
                    src="/assets/images/icon/icon-card.svg"
                    alt=""
                  />ご登録済みのクレジットカード
                </div>
                <div class="l-check-cart__title-sub text-right mb-8">
                  {{cardType == 2 ? 'イオンカード' : 'イオンカード以外（VISA、MASTERのみ）'}}
                </div>
                <div class="c-box-coupon-group">
                  <div class="d-flex justify-content-end mb-8">
                    <a class="c-box-coupon-group__cancel" href="javascript:void(0)" @click.prevent="renewCardProc"
                      >カードを変更する</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="l-check-cart__foot" v-if="user && ((userAeonRegi && !renewCard) || (cartData[0].orderType == 3 && cartData[0].totalAmount == 0)) && index+1 == cartData.length">
              <div class="mb-16" style="line-height: 22px;">
                ご注文状況はアプリで通知させて頂きます。<br />
                <template v-if="cartData[0].handlingFormat == 3">
                  ※ご注文後、「お届け中です」の通知が届いてから、{{mobileOrderConfig.drivethruAreaName}}へお越しください。<br />
                  ※店舗からお持ちするのに5分ほどお時間を要する場合があります。
                </template>
                <template v-if="cartData[0].handlingFormat == 4">
                  ※必ず{{mobileOrderConfig.parkAndPickupAreaName}}に車を停めてからご注文ください。
                </template>
              </div>
              <div class="mb-16">
                <router-link class="checkout-terms" :to="`/about/termsofuse?from-page=${$route.fullPath}`">ご利用規約を確認</router-link>
                <label class="c-checkbox c-checkbox--label">
                  <input type="checkbox" name="checkbox" id="checkbox-2" v-model="agree" />
                  <span class="c-checkbox__checkmark"></span>
                  イオンタウンアプリの規約に同意する
                </label>
              </div>
              <div class="c-btn c-btn--red box-center" @click.prevent="placeOrder">{{cartData[0].handlingFormat == 5 ? '予約': '注文'}}を確定する</div>
            </div>
          </div>
        </div>
      </section>
      <div class="layer" :class="{ fade: !loading }"></div>
      <div class="screen-loader loader--style1" :class="{ fade: !loading }" title="0">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
          <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
          <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"></path>
        </svg>
      </div>
       <alert :message="alert_msg" 
        :show="alert_show" 
        :closeModal="closeModal" 
        :confirm_show="confirm_show" 
        :confirm_message="confirm_msg" 
        :confirm_callback="confirm_callback" 
        :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel"
        :label_ok="confirm_label_ok"
      ></alert>
      <confirm-reservation 
        :callback="confirmCallback" 
        :show="confirmReservationShow" 
        :closeModal="closeConfirmReservationPopup"
       />
      <section>
        <div id="mobile-coupon-modal" class="l-shop l-shop--detail l-shop-overlay fixed" :style="{display: showCoupon ? 'block' : 'none', 'z-index': 302}">
          <div class="l-list-coupon l-list-coupon--detail p-0 fixed" style="width: calc(100% - 30px)">
            <div class="l-main__head--control l-main__head--control--close" @click="closeCoupon()">
              <img src="/assets/images/icon/icon-close-black.svg" alt="" />
            </div>
            <div v-if="mobileOrderCoupons && mobileOrderCoupons.length > 0 && availableCoupons.length > 0" class="mobileCouponDetail-list">
              <div class="mobileCouponDetail" v-for="(coupon, index) in availableCoupons" :key="index">
                  <div class="mobileCouponDetail-title mb-8">{{coupon.title}}</div>
                  <div class="mobileCouponDetail-notice mb-8" v-html="nl2br(coupon.notice)"></div>
                  <button class="c-btn c-btn--center c-btn--white mb-5" style="margin:0; width: 100%" @click.prevent="copyCouponCode(coupon.couponCode)">このクーポンを使う</button>
              </div>
              <div class="mobileCouponDetail">
                <button class="c-btn c-btn--center c-btn--white mb-5" style="margin:0; width: 100%" @click.prevent="clearCouponCode()">クーポンを利用しない</button>
              </div>
            </div>
            <div v-else class="mobileCouponDetail-list">
              <div class="mobileCouponDetail">
                  <div class="mt-8 mb-5">使えるクーポンはありません。</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { DB } from "../config/const";
import firebase from "../common/firebaseProject";
import { getUser, getProviderByShopCategory, getMobileOrderCoupons, getMobileOrderConfig, getOrdersCouponUsed, getOrdersCouponUsedByLineFootprint, deleteUserAeonRegi, getMobileOrderCoupon } from "../store/firestore";
import dayjs from "dayjs";
import ja from 'dayjs/locale/ja';
dayjs.locale(ja);
import PopAlert from "../components/PopAlert.vue";
import ConfirmReservation from "../components/ConfirmReservation.vue";

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default Vue.extend({
  name: "MobileOrderOption",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'alert': Alert,
    PopAlert,
    ConfirmReservation
  },
  mixins: [Tenant],
  async created(){
    const userId = this.$store.state.userId;
    if(userId){
      this.user = await getUser(userId);
    }
    const result = await getProviderByShopCategory(0)
    this.tenants = result;
    this.mobileOrderCoupons = await getMobileOrderCoupons();
    this.mobileOrderConfig = await getMobileOrderConfig();

    // this.autoApplyCoupon();
  },
  data(){
    const cartData = this.$store.state.cart;
    return {
      cartData: Object.values(cartData),
      user: undefined,
      userAeonRegi: undefined,
      tenants: [],
      cardType: null,
      withoutRegisterCard: false,
      watchAeonRegi: false,
      renewCard: false,
      agree: false,
      loading: false,
      showCoupon: false,
      tmpCouponCode: "",
      mobileOrderCoupons: [],
      mobileOrderConfig: null,
      isOrdering: false,
      hasCouponError: false,
      confirmReservationShow: null,
    }
  },
  async mounted() {
    Common.initDom();
    const state = Common.getUrlParam('state');
    const shopId = this.$store.state.shopId;
    const _this = this;
    const userFirestore = DB.collection(`/shop/${shopId}/shopUserAeonRegi`).doc(this.$store.state.userId);
    switch(state){
      case 'waitingregister':
        this.loadingShow();
        this.watchAeonRegi = true;
        userFirestore.onSnapshot(snapshot => {
          const userData = snapshot.data();
          if(userData && userData.aeonRegiId){
            const aeonRegiId = userData.aeonRegiId;
            console.log(`aeonRegiId updated. ${aeonRegiId}`);

            //ここでcreditCardTypeを保存する
            const user = firebase.auth().currentUser;
            const userDoc = DB.collection('user').doc(user.uid);
            userDoc.update({
              creditCardType: parseInt(userData.creditCardType)
            })
            .then(() => {
              this.loadingHide();
              this.$router.push('/mobileorder/checkout/confirm');
            })
          }
        });
        break;
      case 'failure':
        this.alert("カード情報の登録ができませんでした。別のカード情報をご登録いただくか、発行のカード会社にてご確認ください。");
        break;
      case 'cancel':
        this.alert("カード情報の登録がキャンセルされました。このままご注文される場合は、再度カード登録からお手続きください。");
        break;
      default: 
        userFirestore.onSnapshot(snapshot => {
          const data = snapshot.data();
          if (data?.saved) {
            _this.userAeonRegi = data.aeonRegiId;
            _this.cardType = data.creditCardType;
          }
        })
    }
  },
  computed: {
    totalAmount: function() {
      return Object.values(this.$store.state.cart).reduce((total, item) => {
        return total + item.totalAmount
      },0)
    },
    availableCoupons: function() {
      if (!this.mobileOrderCoupons) return [];
      const totalAmount = Object.values(this.$store.state.cart).reduce((total, item) => {
        return total + item.totalAmount + (item.discountAmount||0)
      },0);
      const maxAmountCart = Math.max(...Object.values(this.$store.state.cart).map(item => { return item.totalAmount + (item.discountAmount||0) }))
      const moCoupons = this.mobileOrderCoupons;
      const _available = moCoupons?.filter(item => {
        if (item.totalAmountMaxRestriction > 0 && parseInt(item.totalAmountMaxRestriction, 10) < totalAmount) return false;
        if (item.totalAmountRestriction > 0 && parseInt(item.totalAmountRestriction, 10) > maxAmountCart) return false;
        if (item.tenantSelectedType) {
          let tenantExists = false;
          if (item.tenantSelectedDatas && item.tenantSelectedDatas?.length > 0) {
            for (const tenantCart of Object.values(this.$store.state.cart)) {
              if (tenantCart) {
                if (item.tenantSelectedDatas.map(s => s.tenantId).includes(tenantCart.tenantId)) {
                  console.log(`coupon tenant exists: ${tenantCart.tenantId} ${item.tenantSelectedData}`)
                  tenantExists = true;
                  break;
                }
              }
            }
            return tenantExists;
          } else {
            return true
          }
        }
        return true;
      });
      console.log(`available coupons: ${_available.map(c => c.title)}`)
      return _available;
    },
  },
  methods: {
    getPrice(product,originCart) {
      const taxRateType = this.getTaxRateType(originCart.handlingFormatSetting, originCart.handlingFormat == '2' ? 2 : 1);
      const price = this.getUnitPrice(product, taxRateType);
      return price ? price : 0;
    },
    getTenant(tenantId) {
      if(this.tenants.length) {
        return this.tenants.find(item => item.id == tenantId);
      }
      return undefined;
    },
    getTenantData(tenantId, name) {
      const tenant = this.getTenant(tenantId);
      if (tenant) {
        return tenant[name];
      }
      return false;
    },
    getTenantName(tenantId) {
      return this.getTenantData(tenantId, "shopName")
    },
    getTenantTimebasePickup(tenantId) {
      return this.getTenantData(tenantId, "enableTimebasePickup")
    },
    getTenantTimebaseReservation(tenantId) {
      return this.getTenantData(tenantId, "enableTimebaseReservation")
    },
    getSelectDate(tenantId, orderType) {
      switch(orderType) {
        case 1:
         return this.getTenantTimebasePickup(tenantId);
        case 3:
         return this.getTenantTimebaseReservation(tenantId);
        case 2:
         return false;
       default:
         return false;
      }
    },
    getEstimateTime(tenantCart) {
      const orderType = tenantCart.orderType;
      const tenant = this.getTenant(tenantCart.tenantId);
      if (orderType && tenant){
        const orderTypeString = this.getOrderTypeString(orderType);
        return this.estimateTime(tenant, orderTypeString)
      }
    },
    getProductCount(tenantCart) {
      return tenantCart.orderProducts.reduce((total, item) => {
        return total + item.quantity
      }, 0);
    },
    copyCouponCode(couponCode) {
      this.applyCoupon(couponCode);
      this.showCoupon = false;
    },
    clearCouponCode() {
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        tenantCart.couponCode = "";
        tenantCart.tmpCouponCode = "";
      }
      this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      .then(() => {
        this.tmpCouponCode = "";
      })
      this.cartData = Object.values(cartData);
      this.showCoupon = false;
    },
    viewCoupon() {
      this.showCoupon = true;
    },
    closeCoupon() {
      this.showCoupon = false;
    },
    //クーポンの自動適用
    // async autoApplyCoupon() {
    //   const cartData = {...this.$store.state.cart};
    //   if (this.mobileOrderCoupons.length > 0 && !cartData.couponCode) {
    //     const now = Date.now();
    //     const userId = this.$store.state.userId;
    //     let couponsUsed = {};
    //     let applyCoupon = [];

    //     //MOクーポン適用にあたるチェック
    //     //クーポンがあるかどうか
    //     for (var i=0; i < this.mobileOrderCoupons.length; i ++) {
    //       let flag = false;
    //       let couponData = this.mobileOrderCoupons[i];
    //       if(couponData.hidden) continue;
    //       //期間外
    //       if (couponData.availableFrom > now || couponData.availableTo < now) continue;
          
    //       //使用数オーバー
    //       const usedOrders = await getOrdersCouponUsed(couponData.couponCode, userId);
    //       const usedOrdersByLine = await getOrdersCouponUsedByLineFootprint(couponData.couponCode, this.user.lineFootPrint);
    //       const usedCount = usedOrders?.length + (couponsUsed[couponData.couponCode]||0) + 1;
    //       const usedCountLine = usedOrdersByLine?.length + (couponsUsed[couponData.couponCode] || 0) + 1;

    //       if (couponData.useLimitType != 2) {
    //         // 無制限利用可能でない場合
    //         if (usedCount > 1 || usedCountLine > 1) continue;
    //       }

    //       //使用金額が満たしているかどうか
    //       for (const [key, tenantCart] of Object.entries(cartData)) {
    //         if (tenantCart) {

    //           if(tenantCart.couponCode && tenantCart.couponCode != "") {
    //             this.tmpCouponCode = tenantCart.couponCode; 
    //             //break;
    //           } 

    //           if (tenantCart.orderType == '3') break;
    //           if (couponData.tenantId) {
    //             // テナント発行のクーポンの場合
    //             let hitProduct = false;
    //             tenantCart.orderProducts.forEach((orderProduct, productIndex) => {
    //               const applicableProduct = couponData.applicableProducts.find(applicableProduct => {
    //                 return applicableProduct.productId == orderProduct.productId && orderProduct.price >= parseInt(couponData.discountAmount)
    //               });
    //               if (applicableProduct) {
    //                 hitProduct = true;
    //               }
    //             });
    //             if (!hitProduct) {
    //               continue
    //             }
    //           } else {
    //             // SC発行のクーポンの場合
    //             if (parseInt(tenantCart.taxAmount + tenantCart.priceAmount) < parseInt(couponData.totalAmountRestriction)) continue;
    //             if (parseInt(tenantCart.taxAmount + tenantCart.priceAmount) < parseInt(couponData.discountAmount)) continue;
    //           }
    //           flag = true;
    //         } else {
    //           break;
    //         }
    //       }
    //       if (flag) applyCoupon.push(couponData);
    //     }

    //     //さらに一番金額の大きいクーポンを適用する
    //     // SC発行とテナント発行がある場合、SC発行を優先させる
    //     if (applyCoupon.length > 0) {
    //       if (!this.tmpCouponCode && !this.$route.query.noAutoApplyCoupon) {
    //         let autoApplyCoupon = applyCoupon;
    //         const scCoupons = applyCoupon.filter(coupon => {
    //           return coupon.tenantId == null;
    //         });
    //         if (scCoupons.length > 0) {
    //           autoApplyCoupon = scCoupons;
    //         }
    //         autoApplyCoupon.sort((a, b) => {
    //           if (parseInt(a.discountAmount) < parseInt(b.discountAmount)) return 1;
    //           if (parseInt(a.discountAmount) > parseInt(b.discountAmount)) return -1;
    //           // a は b と等しいはず
    //           if (a.discountAmount == b.discountAmount) {
    //             if (a.availableTo < b.availableTo) return -1;
    //             if (a.availableTo > b.availableTo) return 1;
    //             return 0;
    //           }
    //           return 0;
    //         });
    //         this.applyCoupon(autoApplyCoupon[0].couponCode);
    //       }
          
    //       // 一覧に表示させるクーポンは日付が一番近いもの順に並び替える
    //       applyCoupon.sort((a, b) => {
    //         const day_a = dayjs(a.availableFrom);
    //         const day_b = dayjs(b.availableFrom);
    //         if (day_a.isSameOrBefore(day_b)) return 1;
    //         if (day_a.isSameOrAfter(day_b)) return -1;
    //         return 0;
    //       });
    //       this.mobileOrderCoupons = applyCoupon;
    //     } else {
    //       // 適用できるクーポンがない場合空にする
    //       this.mobileOrderCoupons = [];
    //     }

    //   }
    // },
    async applyCoupon(couponCode) {
      this.loadingShow();
      this.tmpCouponCode = couponCode;
      const couponData = await getMobileOrderCoupon(couponCode);
      const cartData = {...this.$store.state.cart};
      this.hasCouponError = false;
      await this.$store.dispatch('updateCart', { cartData: cartData, couponCode: couponCode })
      .catch(err => {
        this.hasCouponError = true;
        this.tmpCouponCode = "";
        this.loadingHide();
        if(err?.userMessage){
          // クーポン取消
          this.$store.dispatch('updateCart', { cartData, })
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      .then(() => {
        if (!this.hasCouponError) {
          const couponCart = Object.values(this.$store.state.cart).filter(item => item.couponCode?.length > 0);
          if (couponCart) {
            if (couponCart.length == 1) {
              const couponTenant = this.getTenantName(couponCart[0].tenantId);
              console.log(couponTenant, couponData.tenantSelectedType, couponData.tenantSelectedDatas);
              this.alert(`${couponTenant}のご注文にクーポンが適用されました。`);
            } else {
              this.alert("ご注文にクーポンを適用しました");
            }
          }else {
            this.loadingHide();
            this.alert("クーポンコードを入力してください。");
          }
        }
      })
      this.loadingHide();
      this.cartData = Object.values(cartData);
    },
    cancelCoupon(originCart) {
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if(tenantCart.orderId == originCart.orderId){
          tenantCart.couponCode = "";
          tenantCart.tmpCouponCode = "";
        }
      }
      this.$store.dispatch('updateCart', { cartData, })
      .catch(err => {
        if(err?.userMessage){
          this.alert(err.userMessage);
        } else {
          this.alert("エラーが発生しました。");
        }
      })
      .then(() => {
        this.tmpCouponCode = "";
      })
      this.cartData = Object.values(cartData);
    },
    async registerCard() {
      try{
        const user = firebase.auth().currentUser;
        const idToken = await this.getIdToken();
        if (!idToken) return;
        this.loadingShow();
        const callable = firebase.functions('asia-northeast1').httpsCallable('register');
        const result = await callable({ 
          userId: user.uid, 
          shopId: this.$store.state.shopId,
          iid: this.$store.state.installId
        })
        .catch(e => {
          throw e;
        })
        if (result.data.status == 'SUCCEED') {
          //URLのパラメータまで引き継がないように
          const base_url = 'https://'+ document.location.hostname + document.location.pathname;
          const data = Object.assign({
            'dspmode': '01',
            'success_url': base_url + '?state=waitingregister',
            'failure_url': base_url + '?state=failure',
            'cancel_url': base_url + '?state=cancel'
          }, result.data.body);
          this.execPost(result.data.url, data);
        }
      }catch(e){
        this.loadingHide();
        console.error(e);
        this.alert('クレジットカード登録画面へ移動できませんでした。しばらくしてからお手続きください。');
      }
    },
    async renewCardProc() {
      await deleteUserAeonRegi(this.$store.state.userId);
      this.renewCard = true;
    },
    // 日時指定
    registReservationDate(originCart) {
      if (originCart.reservationDate && originCart.reservationTime) {
        var format = dayjs(originCart.reservationDate).format("M/D（dd）");
        let time = originCart.reservationTime;
        if (time == 'am') { time = '午前'; } 
        else if (time == 'pm') { time = '午後'; }
        return format + ' ' + time;
      } else {
        return "ご予約日時が選択されていません。下のボタンを押して選択してください。";
      }
    },
    async placeOrder() {
      if(!this.isUserOrderable()){
        this.alert("モバイルオーダーのご利用にはログイン・本人確認が必要です。");
        return;
      }

      if(this.isOrdering) return;
      this.isOrdering = true;
      if (!this.agree) {
        this.alert("ご利用規約に同意されていません。");
        this.isOrdering = false;
        return;
      }

      //日時選択が必要な場合バリデーション追加
      //enableTimebasePickup enableTimebaseReservation
      const cartData = this.$store.state.cart;

      for (const [key, tenantCart] of Object.entries(cartData)) {
        if (tenantCart) {
          //カードタイプがnullで、合計金額が０円のもの通す
          if(!this.cardType && tenantCart.totalAmount > 0){
            this.alert("クレジットカード情報読み込み中のため、少々お待ちください。");
            return;
          }

          //日時選択
          if (this.getSelectDate(tenantCart.tenantId, tenantCart.orderType)) {
            if (!tenantCart.reservationDate && !tenantCart.reservationTime) {
              this.alert("ご予約日時を選択してください。");
              this.isOrdering = false;
              return;
            }
          }
        } else {
          if(!this.cardType){
            this.alert("クレジットカード情報読み込み中のため、少々お待ちください。");
            return;
          }
        }
      }

      this.loadingShow();
      const idToken = await this.getIdToken();
      if (!idToken) return;
      const userId = this.$store.state.userId;
      const userRef = DB.collection('user').doc(userId);
      const userData = await userRef.get();
      if (this.registerAeonRegi) {
        userRef?.update({
          aeonRegiId: this.userAeonRegi.aeonRegiId
        });
      }
      const couponCode = Object.values(this.$store.state.cart).find(item => item.couponCode?.length > 0)?.couponCode;      
      this.$store.dispatch('updateCart', { cartData: cartData, couponCode: couponCode })
      .then(async () => {
        this.$store.dispatch('placeOrder', this.cardType).then((orderGroupId) => {
          this.loadingHide();
          this.isOrdering = false;
          this.$router.push('/mobileorder/complete/'+orderGroupId);
        })
        .catch(async e => {
          this.loadingHide();
          this.isOrdering = false;
          console.error(e);
          await this.confirm("注文確定処理時にエラーが発生しました。" + (e?.message||""), true);
          this.$router.push('/mobileorder/cart?from-page=checkout');
          return;
        })
      })
      .catch(async e => {
        this.loadingHide();
        this.isOrdering = false;
        console.error(e);
        await this.confirm("注文確定処理時にエラーが発生しました。" + (e?.message||""), true);
        this.$router.push('/mobileorder/cart?from-page=checkout');
        return;
      })
    },
    execPost(action, data) {
      var form = document.createElement("form");
      form.setAttribute("action", action);
      form.setAttribute("method", "post");
      form.style.display = "none";
      document.body.appendChild(form);
      if (data !== undefined) {
        for (var paramName in data) {
        var input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', paramName);
        input.setAttribute('value', data[paramName]);
        form.appendChild(input);
        }
      }
      form.submit();
    },
    showCalendar(originCart) {
      this.$router.push(`/mobileorder/${originCart.tenantId}/${originCart.orderId}/calendar`);
      //this.$router.push(`/mobileorder/shop/${tenantCart.tenantId}/option`);
    },
    //来店予約かどうかで戻りの状態を変更する
    isShowConfirmReservation() {
      var orderType = false;
      for (var i=0; i < this.cartData.length; i++) {
        if (this.cartData[i].orderType) {
          orderType = (this.cartData[i].orderType == 3) ? true : false;
          break;
        }
      }
      if (orderType) {
        this.confirmReservationShow = true;
      } else {
        this.backPagePrevious();
      }
    },
    isEnableTimebase(cartData) {
      const tenant = this.getTenant(cartData.tenantId);
      if (tenant && (cartData.orderType == 1 && tenant.enableTimebasePickup) || (cartData.orderType == 3 && tenant.enableTimebaseReservation)) {
        return false;
      } 
      return true;
    },
    closeConfirmReservationPopup() {
      this.confirmReservationShow = false;
    },
    // カートクリア
    async confirmCallback()  {
      let tenantId,orderType;
      for (var i=0; i < this.cartData.length; i++) {
        if (this.cartData[i].tenantId) {
          tenantId = this.cartData[i].tenantId;
          orderType = this.cartData[i].orderType;
          break;
        }
      }
      if (tenantId && orderType == 3) {
          //来店予約の時にカート情報消して詳細画面戻る
        await this.$store.dispatch('clearCart');
        this.$router.push(`/mobileorder/shop/${tenantId}/reservation`);
      } else {
        this.backPagePrevious();
      }    
    }
  }
})
</script>